import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-zinc-950 text-white relative overflow-hidden">
    <div className="w-full h-px bg-gradient-to-r from-transparent via-yellow-400/60 to-transparent" />

    {/* CTA Banner */}
    <div className="border-b border-zinc-900">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 md:py-12 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="text-center md:text-left">
          <p className="font-display text-2xl md:text-3xl uppercase text-white tracking-wide">
            ¿Listo para traer tu vehículo?
          </p>
          <p className="text-zinc-500 text-sm mt-1.5 font-light">Presupuesto sin compromiso en menos de 24 horas</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
          <a
            href="https://wa.me/34666365922?text=Hola,%20quisiera%20pedir%20presupuesto"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-emerald-600 text-white text-xs font-bold uppercase tracking-widest px-6 py-3 hover:bg-emerald-500 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line" />
            WhatsApp
          </a>
          <Link
            to="/contacto"
            className="inline-flex items-center gap-2 bg-yellow-400 text-black text-xs font-bold uppercase tracking-widest px-6 py-3 hover:bg-yellow-300 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Pedir presupuesto <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </div>

    {/* Main footer */}
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-12 md:py-16">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 gap-10 md:gap-12">
        {/* Brand */}
        <div className="sm:col-span-2 md:col-span-5 space-y-5">
          <Link to="/" className="inline-block cursor-pointer">
            <img
              alt="Taller Kevin Alberto"
              className="h-10 md:h-12 w-auto object-contain"
              src="https://static.readdy.ai/image/ddfb463a64ca8c28bad8258e53257cac/7fa385eb80b3da87383713583b172ef6.png"
            />
          </Link>
          <p className="text-zinc-500 text-sm leading-relaxed max-w-xs font-light">
            Tu taller de confianza en Ronda, Málaga. Mecánica profesional para cualquier coche o moto,
            con especialistas para cualquier problema.
          </p>
          <div className="flex items-center gap-3">
            {[
              { href: 'https://wa.me/34666365922', icon: 'ri-whatsapp-line' },
              { href: 'https://www.facebook.com/taller.mecanico.Kevin/', icon: 'ri-facebook-line' },
            ].map((s) => (
              <a
                key={s.icon}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-zinc-800 text-zinc-500 hover:border-yellow-400 hover:text-yellow-400 transition-all duration-300 cursor-pointer"
              >
                <i className={`${s.icon} text-base`} />
              </a>
            ))}
          </div>
        </div>

        {/* Navigation */}
        <div className="md:col-span-3">
          <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-yellow-400 mb-5">Navegación</p>
          <nav className="flex flex-col gap-3.5">
            {[
              { label: 'Inicio', to: '/' },
              { label: 'Nosotros', to: '/nosotros' },
              { label: 'Servicios', to: '/servicios' },
              { label: 'Compraventa', to: '/compraventa' },
              { label: 'Contacto', to: '/contacto' },
            ].map((link) => (
              <Link
                key={link.label}
                to={link.to}
                className="text-zinc-500 hover:text-white text-sm transition-colors duration-300 cursor-pointer flex items-center gap-2 group font-light"
              >
                <span className="w-0 h-px bg-yellow-400 group-hover:w-4 transition-all duration-300" />
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        {/* Contact */}
        <div className="md:col-span-4">
          <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-yellow-400 mb-5">Contacto</p>
          <div className="space-y-3.5">
            {[
              { href: 'tel:+34666365922', icon: 'ri-phone-line', text: '+34 666 36 59 22' },
              { href: 'https://wa.me/34666365922', icon: 'ri-whatsapp-line', text: '+34 666 36 59 22', ext: true },
              { href: 'mailto:tallerkevinalberto@gmail.com', icon: 'ri-mail-line', text: 'tallerkevinalberto@gmail.com' },
            ].map((c) => (
              <a
                key={c.icon}
                href={c.href}
                target={c.ext ? '_blank' : undefined}
                rel={c.ext ? 'noopener noreferrer' : undefined}
                className="flex items-center gap-3.5 text-zinc-500 hover:text-yellow-400 text-sm transition-colors cursor-pointer group"
              >
                <div className="w-7 h-7 flex items-center justify-center border border-zinc-800 group-hover:border-yellow-400/30 flex-shrink-0">
                  <i className={`${c.icon} text-xs`} />
                </div>
                <span className="truncate font-light">{c.text}</span>
              </a>
            ))}
            <div className="flex items-center gap-3.5 text-zinc-500 text-sm">
              <div className="w-7 h-7 flex items-center justify-center border border-zinc-800 flex-shrink-0">
                <i className="ri-map-pin-line text-xs" />
              </div>
              <span className="font-light">C. Guadalimar, 7, Ronda, Málaga</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Copyright */}
    <div className="border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 pb-20 md:pb-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-zinc-600 text-xs font-light">2026 © Taller Kevin Alberto. Todos los derechos reservados.</p>
        <Link to="/aviso-legal" className="text-zinc-700 hover:text-zinc-400 text-xs transition-colors cursor-pointer font-light">
          Aviso Legal
        </Link>
      </div>
    </div>

    {/* Mobile bottom bar */}
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      <div className="bg-zinc-950/98 backdrop-blur-sm border-t border-zinc-800 px-3 py-3 flex gap-2">
        <a
          href="https://wa.me/34666365922?text=Hola,%20quisiera%20pedir%20presupuesto"
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 flex items-center justify-center gap-2 bg-emerald-600 text-white py-3 text-xs font-bold uppercase tracking-wider cursor-pointer whitespace-nowrap rounded-lg"
        >
          <i className="ri-whatsapp-line text-base" />
          WhatsApp
        </a>
        <Link
          to="/contacto"
          className="flex-1 flex items-center justify-center gap-2 bg-yellow-400 text-black py-3 text-xs font-bold uppercase tracking-wider cursor-pointer whitespace-nowrap rounded-lg"
        >
          <i className="ri-calendar-line text-base" />
          Pedir Cita
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
